// Shipping rates by product category (editable)
export const SHIPPING_RATES = {
  "shirt": 8.00,
  "hoodie": 12.00,
  "limited-edition-print": 15.00,
  "print": 10.00,
  "original-painting": 75.00,
  "book": 6.00,
  "paper-goods": 5.00,
  "hat": 8.00,
  "default": 10.00
};

// Colorado state sales tax
export const SALES_TAX_RATE = 0.029; // 2.9%

// Product category mapping
export const PRODUCT_CATEGORIES = {
  // Limited Edition Prints
  "lep-001": "limited-edition-print",
  "lep-002": "limited-edition-print",
  "lep-003": "limited-edition-print",
  "lep-004": "limited-edition-print",
  "lep-005": "limited-edition-print",
  "lep-006": "limited-edition-print",
  "lep-007": "limited-edition-print",
  
  // Original Paintings
  "op-001": "original-painting",
  "op-002": "original-painting",
  "op-003": "original-painting",
  "op-004": "original-painting",
  "op-005": "original-painting",
  "op-006": "original-painting",
  "op-007": "original-painting",
  "op-008": "original-painting",
  "op-009": "original-painting",
  "op-010": "original-painting",
  "op-011": "original-painting",
  "op-012": "original-painting",
  "op-013": "original-painting",
  "op-014": "original-painting",
  "op-015": "original-painting",
  "op-016": "original-painting",
  "op-017": "original-painting",
  "op-018": "original-painting",
  "op-019": "original-painting",
  
  // Apparel - Hoodie
  "ap-001": "hoodie",
  
  // Apparel - Shirt
  "ap-002": "shirt",
  
  // Apparel - Hats
  "ap-003": "hat",
  "ap-004": "hat",
  
  // Children's Books
  "cb-001": "book",
  "cb-002": "book",
  
  // Paper Goods
  "pg-001": "paper-goods",
  "pg-002": "paper-goods",
  "pg-003": "paper-goods",
  "pg-004": "paper-goods",
  
  // Prints
  "pr-001": "print",
  "pr-002": "print",
  "pr-003": "print",
  "pr-004": "print",
  "pr-005": "print",
  "pr-006": "print",
  "pr-007": "print",
  "pr-008": "print",
  "pr-009": "print",
  "pr-010": "print",
  "pr-011": "print",
  "pr-012": "print",
  "pr-013": "print",
  "pr-014": "print",
  "pr-015": "print",
  "pr-016": "print",
  "pr-017": "print"
};

// Get shipping rate for a product
export const getShippingRate = (productId) => {
  const category = PRODUCT_CATEGORIES[productId] || "default";
  return SHIPPING_RATES[category] || SHIPPING_RATES.default;
};

// Calculate shipping for cart items
export const calculateShipping = (items) => {
  if (!items || items.length === 0) return 0;
  
  // Find the highest shipping rate among all items (flat rate based on highest)
  let maxShippingRate = 0;
  
  items.forEach(item => {
    const rate = getShippingRate(item.product.id);
    const itemShipping = rate * item.quantity;
    if (itemShipping > maxShippingRate) {
      maxShippingRate = itemShipping;
    }
  });
  
  return maxShippingRate;
};

// Calculate tax
export const calculateTax = (subtotal) => {
  return subtotal * SALES_TAX_RATE;
};
